import { base } from '@modules';

import { ModuleDetailsSchema } from './ModuleDetails.schema';

export const initialState: ModuleDetailsSchema = {
  ...base.state,
  data: null,
};
